import React from 'react';

import { Leading } from '../Leading';
import { Card } from '@sandtech-hub-monorepo/ui-kit';

import learningBanner from '../assets/banners/learning-banner.webp';
import { useGetMaybeViewer } from '@sandtech-hub-monorepo/ui-auth-kit';
import { useScrollRestoration } from '../../utils';
import { SupportCard } from './components/SupportCard';
import { ProgramStatusManagementCard } from './components/ProgramStatusManagementCard';
import { ProgramEnrollmentsView } from './ProgramEnrollmentsView';
import { ProgramsPreview } from '../Program/components/ProgramsPreview';

export const Learning = ({
  paymentFAQsLink,
  programPageLink,
  learningPageLink,
  programsPageLink,
  supportPageLink,
  universityOnly,
}: {
  paymentFAQsLink: string;
  programPageLink: string;
  learningPageLink: string;
  programsPageLink: string;
  supportPageLink: string;
  /** See ProgramsPreview's own prop doc - threaded through to its "Recommended Programs" section. */
  universityOnly?: boolean;
}) => {
  const { viewer } = useGetMaybeViewer();
  useScrollRestoration();
  return (
    <>
      <Leading
        pageName="Your Learning Resources"
        title="View Your Program and Track Your Progress"
        img={learningBanner}
        subtitle="Find detailed information about your enrolled program here."
      />

      <div className="flex flex-col gap-8 bg-background-tertiary pt-8 pb-12 px-4 sm:pt-16 sm:pb-24 sm:px-20">
        <div className={'w-full h-fit'}>
          <div className="flex flex-col gap-4 w-full">
            <span className="font-bold text-2xl mb-4 text-heading">
              Current Programs
            </span>
            <ProgramEnrollmentsView
              type={'current'}
              paymentFAQsLink={paymentFAQsLink}
              showOngoingCoursesToggle
            />
            <span className="font-bold text-2xl mb-4 text-heading">
              Past Programs
            </span>
            <ProgramEnrollmentsView
              type={'past'}
              paymentFAQsLink={paymentFAQsLink}
            />
          </div>
        </div>
        <ProgramsPreview
          title="Recommended Programs"
          programPageLink={programPageLink}
          learningPageLink={learningPageLink}
          programsPageLink={programsPageLink}
          cardVariant={'detailed'}
          universityOnly={universityOnly}
        />
        <Card className="p-9">
          <h2 className="text-3xl font-semibold text-center mb-8">
            Need assistance with your course?
          </h2>
          <div className="flex gap-5 sm:flex-row flex-col flex-wrap">
            <SupportCard
              answeBaseEnabled={
                viewer?.enrollmentFeatureAccess.hasAnswerbaseAccess
              }
              supportPageLink={supportPageLink}
            />
            <ProgramStatusManagementCard />
          </div>
        </Card>
      </div>
    </>
  );
};
